import { render, staticRenderFns } from "./PosAtendimento.vue?vue&type=template&id=69cd92ba&scoped=true"
import script from "./PosAtendimento.vue?vue&type=script&lang=js"
export * from "./PosAtendimento.vue?vue&type=script&lang=js"
import style0 from "./PosAtendimento.vue?vue&type=style&index=0&id=69cd92ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69cd92ba",
  null
  
)

export default component.exports